"use client";

import createIcon from './util/createIcon';
export default createIcon('M13.05,4.24L6.56,18.05L2,18L7.09,9.24L13.05,4.24M13.75,5.33L22,19.76H6.74L16.04,18.1L11.17,12.31L13.75,5.33Z', 'MicrosoftAzure');